export default [
    { value: "admin", label: "Админ" },
    { value: "provider", label: "Исполнитель" },
    { value: "client", label: "Клиент" },
    { value: "courier", label: "Экспедитор" },
]
